import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import SpecItem from 'components/display/SpecItem'
import styles from './styles.scss'
import { SPEC_ORDER } from './constants'
import T from 'i18n-react'

class SpecTable extends Component {
  renderItems(){
    const {
      moduleName,
      moduleData,
      compact,
      padded
    } = this.props

    const specOrder = SPEC_ORDER[moduleName]
    return specOrder.filter((specName) => {
      return (moduleData[specName] && moduleData[specName] !== null)
    }).map((specName, index) => {
      const label = T.translate(`specs.${moduleName}.${specName}`)
      return (
        <SpecItem padded={padded} compact={compact} key={index} label={label} value={moduleData[specName]} />
      )
    })
  }

  render() {
    return(
      <div className={this.props.className} styleName='tableContainer'>
        {this.renderItems()}
      </div>
    )
  }
}

export default CSSModules(styles)(SpecTable)
